import { useParams } from "react-router-dom";
import CreateProfilePage from "@/pages/create-profile/CreateProfilePage";

export default function AdminCompanyFullEditPage() {
  const { id } = useParams<{ id: string; }>();

  if (!id) {
    return null;
  }

  return <CreateProfilePage mode="edit" adminCompanyId={id} adminReturnPath={`/admin/companies/${id}`} />;
}
